import { render } from "./HomeNewsBox.vue?vue&type=template&id=350435d8&scoped=true"
import script from "./HomeNewsBox.vue?vue&type=script&lang=js"
export * from "./HomeNewsBox.vue?vue&type=script&lang=js"

import "./HomeNewsBox.vue?vue&type=style&index=0&id=350435d8&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350435d8"]])

export default __exports__